import { client } from '@/lib/api/client'
import { venueRevenueDashboardPath, venueRevenuePath } from '@/lib/api/config'
import { toApiError } from '@/lib/api/errors'

import type { VenueRevenueDashboardView, VenueRevenueView } from './revenueTypes'
import { revenueQueryParams, type RevenueListFilter } from './revenueViewModel'

/**
 * `GET .../revenues` (#792 §2) — 매출 현황(요약 4종 + 예약별 목록), 결제 시점 수수료 스냅샷 기준.
 * 🚨 게이팅 대상이 아니다 — 이용권이 모두 만료돼도 항상 200. `cursor`는 서버가 준 `nextCursor` 문자열을
 * 그대로 되싣는다(해석·가공하지 않는다).
 */
export async function fetchVenueRevenue(
  venueId: string,
  filter: RevenueListFilter,
  cursor?: string
): Promise<VenueRevenueView> {
  try {
    const { data } = await client.get<VenueRevenueView>(venueRevenuePath(venueId), {
      params: revenueQueryParams(filter, cursor),
    })
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * `GET .../revenues/dashboard` (#792 §3) — 대시보드 "이번 달 매출 요약". 파라미터 없음(서버가 KST
 * "이번 달"을 판정한다 — 화면이 자체 계산해 보내지 않는다).
 */
export async function fetchVenueRevenueDashboard(venueId: string): Promise<VenueRevenueDashboardView> {
  try {
    const { data } = await client.get<VenueRevenueDashboardView>(venueRevenueDashboardPath(venueId))
    return data
  } catch (error) {
    throw toApiError(error)
  }
}
